module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/home/home-tab/home-cells-view/donut-chart/donut-chart.component.scss
// module id = ./src/app/entities/home/home-tab/home-cells-view/donut-chart/donut-chart.component.scss
// module chunks = main